export const getUTCFormattedDate = (date: Date | number, includeTime: boolean): string => {
  const dateAsDate = new Date(date);

  const isoString = dateAsDate.toISOString();
  const dateString = isoString.substr(0, 10);

  if (!includeTime) {
    return dateString;
  }

  const timeString = isoString.substr(11, 8);

  return `${dateString} ${timeString}`;
};
